import { render, staticRenderFns } from "./FullList.vue?vue&type=template&id=e35e4424&"
import script from "./FullList.vue?vue&type=script&lang=js&"
export * from "./FullList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports